import types from '../constants/types'

export const authorityMutation = {
  [types.LOGIN_REQUEST] (state) {
    state.isLogining = true
    state.msg = '正在请求登录账户'
  },
  [types.LOGIN_SUCCESS] (state, action) {
    state.isLogining = false
    state.logged = true
    state.userInfo = action.data.info
    state.msg = action.data.msg
    state.loginFailure = false
  },
  [types.LOGIN_FAILURE] (state, action) {
    state.isLogining = false
    state.logged = false
    state.loginFailure = true
    state.msg = action.data.msg
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations/authority.js